import React, { useLayoutEffect, useState, useEffect, useRef } from 'react'

import DataGrid, {
    Column,
    Export,
    HeaderFilter,
    MasterDetail,
    Pager,
    Paging,
    SearchPanel,
} from "devextreme-react/data-grid";
import { Button, DateBox, SelectBox, TextBox, RadioGroup } from "devextreme-react";
import TextArea from "devextreme-react/text-area";
import Popup from "devextreme-react/popup";
import { useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react";
import Swal from 'sweetalert2';
import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";
import { IOMService } from '../../../apis/apiServices/InterOfficeMemo(IOM)'
import { MyTaskService } from '../../../apis/apiServices/MyTask'
import { pendingCount } from '../../../redux/IOMPendingCount';
import { SetSessionItem } from '../../../helper/appsession';
import { ProjectService } from '../../../apis/apiServices/Project'
import { PaymentRequestService } from '../../../apis/apiServices/PaymentRequest';
import { CompanyService } from '../../../apis/apiServices/Company';
import { MsmeService } from '../../../apis/apiServices/Msme'
import PaymentDetailsModal from '../../common/Modal/PaymentDetailsModal';

export default function MyTaskComponent(props) {

    const navigate = useNavigate();
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        projectId: "",
    });
    const [filterErrors, setFilterErrors] = useState({
        fromDate: "",
        toDate: "",
        projectId: "",
    });
    const dispatch = useDispatch();
    const [errors, setErrors] = useState({});
    const [iomList, setIOMList] = useState(null);
    const [pendingIOMCount, setPendingIOMCount] = useState(null);
    const [filteredList, setFilteredList] = useState(null);
    const user = useSelector((state) => state.user.data);
    const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
    const [remarks, setRemarks] = useState("");
    const [error, setError] = useState("");
    const [rowIOMId, setIOMId] = useState("");
    const [projectDropdownData, setProjectDropdownData] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);

    const [selectedCompanyBankId, setSelectedCompanyBankId] = useState(null);
    const [isitemDetailsModalVisible, setIsitemDetailsModalVisible] = useState(false);
    const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
    const [companyBankData, setCompanyBankData] = useState(null);
    const [paymentDeatilsSrno, setPaymentDetailsSrno] = useState(null);
    const [paymentDeatilsByPrId, setPaymentDetailsByPrId] = useState(null);
    const [payment, setPayment] = useState({
        vendorName: '',
        balanceAmt: '',
        recommendedAmt: '',
        paidAmt: '',
        paidDate: '',
        transcationNumber: '',
        narration: '',
        paymentRequestId: '',
        itemId: 0,
        itemSerialNo: '',
        advPaymentRequestId: ''
    });
    const [msme, setMsmeList] = useState(null);
    const [paymentModeList, setPaymentModeList] = useState(null);
    const [paymentOptionList, setPaymentOptionList] = useState(["Bank", "MSME"]);
    const [paymentOption, setPaymentOption] = useState(null);
    const [selectedMsmeId, setSelectedMsmeId] = useState(null);

    // const getProjectDropdownData = async () => {
    //     try {
    //         let body = {}
    //         const response = await ProjectService.getProjectDropdown(body)
    //         setProjectDropdownData(response?.data);
    //     } catch (error) {
    //         console.log("Error getProjectList===>", error);
    //     }
    // }

    const getProjectDropdownData = async () => {
        try {
            const response = await ProjectService.getProjectByUserId(user?.userId)
            setProjectDropdownData(response?.data);
        } catch (error) {
            console.log("Error getProjectDropdownData===>", error);
        }
    }

    const getMyTaskList = async (isIgnoreFilters) => {
        try {
            let body = {
                UserId: user.userId,
                fromDate: (filters?.fromDate && isIgnoreFilters !== true) ? ConvertDateToddMMyyyy(filters?.fromDate) : null,
                toDate: (filters?.toDate && isIgnoreFilters !== true) ? ConvertDateToddMMyyyy(filters?.toDate) : null,
                projectId: (filters?.projectId && isIgnoreFilters !== true) ? filters?.projectId : 0,
                isMyTask: true
            }
            const response = await MyTaskService.getMyTaskList(body)
            const filteredData = response?.data

            const filteredCount = filteredData?.length;
            setPendingIOMCount(filteredCount);
            dispatch(pendingCount(filteredCount));
            SetSessionItem("pendingCount", filteredCount);
            setIOMList(filteredData);
            // getFilteredList([8, 4], response?.data)
        } catch (error) {
            console.log("Error getMyTaskList===>", error);
        }
    }

    const handleFilterChange = (key, value) => {
        setFilters(prevState => {
            return {
                ...prevState,
                [key]: value
            }
        });
    }

    const ConvertDateToddMMyyyy = (date) => {
        if (!date) return "";

        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();

        day = day < 10 ? '0' + day : day;
        month = month < 10 ? '0' + month : month;

        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    }
    const ConvertddMMyyyyToDate = (dateStaring) => {
        if (!dateStaring) return "";
        let date = new Date(dateStaring)
    }

    useEffect(() => {
        getMyTaskList();
    }, [])

    // useEffect(() => {
    //     if (iomLatestPendingCount === 0 && !hasReloaded.current) {
    //         hasReloaded.current = true; // set the flag
    //         window.location.reload();
    //     }
    // }, [iomLatestPendingCount]);

    const handleRemarksChange = (e) => {
        setRemarks(e.value);
        if (error) setError(""); // clear error on typing
    };

    const handleSubmit = () => {
        if (!remarks) {
            setError("Please enter remarks");
            return;
        }
        setError("");
        setIsDeleteModalVisible(false);
        deleteIoM();  // Now call your existing function
    };

    const deleteIoM = async () => {
        //e.preventDefault();
        if (!remarks.trim()) {
            setError("Please enter remarks");
            return;
        }
        setIsDeleteModalVisible(false);
        setRemarks("");

        let body = {
            userId: user.userId,
            //updatedOn: new Date().toISOString(),
            remarks: remarks || "",
            //IsRecommededUser: user?.userId === iomData?.recommendId ? true : false,
            iomId: rowIOMId || 0,
        };
        const response = await IOMService.deleteIOM(body);
        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.data?.message}`,
                "error"
            );
            return;
        }
        Swal.fire(
            "Success!",
            `${response?.message}`,
            "success"
        ).then(() => { navigate(`/inter-office-memo`) });
    };

    const getFilteredList = (iomStatusIds, newIomList) => {

        let newFilteredList = newIomList
            ? newIomList?.filter(iom => iomStatusIds?.includes(iom?.iomStatusId))
            : iomList?.filter(iom => iomStatusIds?.includes(iom?.iomStatusId))

        setFilteredList(newFilteredList);
    }

    const getMsmeList = async () => {
        try {
            const response = await MsmeService.getMsmeList()
            const fiterData = response?.data.filter(item => item?.isActive === true)
            setMsmeList(fiterData);
        } catch (error) {
            console.log("Error getMsmeList===>", error);
        }
    }

    const getPaymentModeList = async () => {
        try {
            const response = await PaymentRequestService.getPaymentModeList()
            const fiterData = response?.data.filter(item => item?.isActive === true)
            setPaymentModeList(fiterData);
        } catch (error) {
            console.log("Error getMsmeList===>", error);
        }
    }

    const handlePaymentSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitted(true);

        const newErrors = {};
        if ((paymentOption === true) && !payment?.companyBankId) { newErrors.companyBankId = "Please select bank"; }
        if ((paymentOption === false) && !payment?.msmeId) { newErrors.msmeId = "Please select MSME"; }
        if (paymentOption === null) newErrors.paymentOption = "Please select payment option";
        if (!payment?.narration) newErrors.narration = "Please enter narration";
        if (!payment?.transcationNumber) newErrors.transcationNumber = "Please enter transaction number";
        if (!payment?.paidDate) newErrors.paidDate = "Please select date";
        if (!payment?.paymentModeId) newErrors.paymentModeId = "Please select payment mode";
        if ((payment?.paymentModeId === 2 || payment?.paymentModeId === 3) && !payment?.chequeDate) newErrors.chequeDate = "Please select cheque date";
        if ((payment?.paymentModeId === 2 || payment?.paymentModeId === 3) && !payment?.chequeNo) newErrors.chequeNo = "Please enter cheque number";
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setIsSubmitted(false);
            return;
        }

        const formatDate = (date) => {
            if (!date) return null;
            const d = new Date(date);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, "0");
            const day = String(d.getDate()).padStart(2, "0");
            return `${year}-${month}-${day}`;
        };

        let body = {
            paymentRequestId: payment?.paymentRequestId,
            itemId: payment?.itemId,
            itemSerialNo: payment?.itemSerialNo,
            companyBankId: payment?.companyBankId,
            paidOn: formatDate(payment?.paidDate),
            transactionNo: payment?.transcationNumber,
            narration: payment?.narration,
            modifiedBy: user?.userId,
            msmeId: payment?.msmeId || 0,
            paymentModeId: payment?.paymentModeId || 0,
            paymentMode: paymentOption,
            chequeDate: formatDate(payment?.chequeDate),
            chequeNo: payment?.chequeNo

        };

        const response = await PaymentRequestService.Payment(body);

        if (!response?.isSuccess) {
            Swal.fire(
                "Error!",
                `${response?.message || "Something went wrong"}`,
                "error"
            ); setIsSubmitted(false);
            return;
        }

        Swal.fire(
            "Success!",
            // `${response?.message || bank?.id > 0 ? "Bank updated successfully" : "Bank added successfully"}`,
            `${response?.message || "payment done successfully"}`,
            "success"
        ).then(() => { navigate("/pending-ioms"); });
    };
    const handleValueChange = (field, value) => {
        setPayment(prev => ({
            ...prev,
            [field]: value
        }));

        // Optional: Clear validation error when field changes
        setErrors(prev => ({
            ...prev,
            [field]: ''
        }));
        // 👇 If this is the company bank selection, update local state
        if (field === "companyBankId") {
            setSelectedCompanyBankId(value);
        }
    };

    const getCompanyBankDetails = async (projectId) => {
        try {
            let body = {
                'projectId': projectId,
            }
            const response = await CompanyService.getCompanyBankDetails(body)
            setCompanyBankData(response?.data);
        } catch (error) {
            console.log("Error getCompanyBankDetails===>", error);
        }
    }
    const getPaymentDeatilsByPrItemId = async (itemId, serialNo) => {
        try {
            const response = await PaymentRequestService.getitemPaymentDetailsById(itemId)
            const paymentSrNo = { paymentRequestId: response?.data, itemSerialNo: serialNo }
            setPaymentDetailsByPrId(response?.data, serialNo);
            setPaymentDetailsSrno(serialNo)

            setIsitemDetailsModalVisible(true)
        } catch (error) {
            console.log("Error getPaymentDeatilsByPrItemId===>", error);
        }
    }
    const openAddModal = (rowData, data) => {

        getMsmeList();
        getPaymentModeList();
        setIsPaymentModalOpen(true);
        getCompanyBankDetails(data?.projectId);
        setPayment({
            vendorName: rowData?.vendorName,
            balanceAmt: rowData?.balanceAmt,
            recommendedAmt: rowData?.recommendedAmt,
            paidAmt: rowData?.paidAmt,
            paymentRequestId: data?.paymentRequestId,
            itemId: rowData?.itemId,
            itemSerialNo: rowData?.itemSerialNo,
            advPaymentRequestId: rowData?.advPaymentRequestId
        });
    };
    const closeModal = () => {
        setIsPaymentModalOpen(false);
        setIsSubmitted(false);
        setErrors({});
        setIsitemDetailsModalVisible(false);
        setPaymentDetailsByPrId(null);
        // setCompanyBankData(null);
        setSelectedCompanyBankId(null);
        setPaymentOption(null);
        // setBank({
        //     bankName: '',
        //     bankId: '',
        //     isActive: true,
        //     id: 0,
        // });
        // setBranches([]);
    };

    const DetailContent = ({ detailData }) => {
        const data = detailData?.key;
        const [itemData, setItemData] = useState([]);
        const [loading, setLoading] = useState(true);

        useEffect(() => {
            const fetchData = async () => {
                try {
                    const res = await PaymentRequestService.getPaymentRequestItemsByRequestId(data?.requestId || 0, user?.userId || 0);
                    setItemData(res?.isSuccess ? res.data : []);
                } catch (err) {
                    console.error("Error fetching details:", err);
                    setItemData([]);
                } finally {
                    setLoading(false);
                }
            };
            fetchData();
        }, [data?.requestId, user?.userId]);

        if (loading) {
            return <div style={{ padding: 10 }}>Loading details...</div>;
        }

        return (
            <DataGrid
                dataSource={itemData}
                //columnAutoWidth
                columnAutoWidth={true}
                showBorders
                showRowLines
                showColumnLines={false}
                noDataText="No details"
            >
                <Column
                    width="55px"
                    cellRender={(cellData) => {
                        //debugger
                        const rowData = cellData?.data;
                        return (
                            <>

                                {
                                    !rowData?.paidOn ?
                                        <button
                                            className="btn btn-outline-success btn-sm"
                                            style={{ padding: "0px 8px", margin: "0px", fontSize: "0.78rem", borderRadius: "50px", cursor: 'pointer' }}
                                            title='Pay'
                                            tooltip='Pay'
                                            onClick={() => openAddModal(rowData, data)}
                                        >Pay</button>
                                        :
                                        <span title='Payment'>
                                            {/* <Icon
                                                title="Payment"
                                                className='iconify-size mr-1'
                                                icon="streamline-ultimate:cash-payment-bill-bold"
                                                style={{ cursor: 'pointer', pointerEvents: 'none', opacity: '0.3' }}
                                            /> */}
                                        </span>
                                }
                            </>
                        );
                    }}
                />
                {/* <Column
                    width="35px"
                    cellRender={(cellData) => {
                        const rowData = cellData?.data;
                        return (
                            <>
                                {!rowData?.paidOn
                                    ? (
                                        <span title="Payment">
                                            <Icon
                                                title="Payment"
                                                className="iconify-size mr-1"
                                                icon="streamline-ultimate:cash-payment-bill-bold"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => openAddModal(rowData, data)}
                                            />
                                        </span>
                                    )
                                    : (
                                        <span title="Payment"></span>
                                    )}
                            </>
                        );
                    }}
                /> */}

                <Column dataField="itemSerialNo" allowSearch={true} caption="Serial No." />
                <Column dataField="vendorName" caption="Vendor" />
                <Column
                    dataField="bankName"
                    caption="Bank"
                    width={100}
                    cellRender={(e) => (
                        <div>
                            <div>{e.data?.bankName}</div>
                            <div style={{ fontSize: "11px", color: "#b1b1b1" }}>
                                {e.data?.branchName}
                            </div>
                        </div>
                    )}
                />
                <Column
                    dataField="balanceAmt"
                    caption="Ledger Balance"
                    allowFiltering={false}
                    width={100}
                    cellRender={(e) => (
                        <div>{e.data?.balanceAmt?.toLocaleString("en-IN")}</div>
                    )}
                />
                <Column
                    dataField="recommendedAmt"
                    caption="Recommended Amt."
                    allowFiltering={false}
                    width={150}
                    cellRender={(e) => (
                        <div>{e.data?.recommendedAmt?.toLocaleString("en-IN")}</div>
                    )}
                />
                <Column
                    dataField="paidAmt"
                    caption="Paid Amt."
                    allowFiltering={false}
                    width={100}
                    cellRender={(e) => (
                        <div>{e.data?.paidAmt?.toLocaleString("en-IN")}</div>
                    )}
                />
                <Column
                    dataField="advPaymentRequestId"
                    caption="Advance request id"
                    allowFiltering={false}
                    width={100}
                    cellRender={(e) => (
                        <div style={{ textAlign: "center" }}>{e.data?.advPaymentRequestId}</div>
                    )}
                />
                <Column
                    caption="Payment Status"
                    cellRender={(e) => (
                        <div style={{ textAlign: "center" }}>
                            {e.data?.paidOn ? (
                                <div title="More Info">
                                    <Icon
                                        icon="material-symbols:check-circle-outline-rounded"
                                        title="Payment Done"
                                        style={{ color: "green", fontSize: "20px", cursor: "pointer" }}
                                        onClick={() =>
                                            getPaymentDeatilsByPrItemId(
                                                e.data?.itemId,
                                                e.data?.itemSerialNo
                                            )
                                        }
                                    />
                                    <div style={{ fontSize: "11px", color: "#b1b1b1" }}>
                                        {(() => {
                                            const d = new Date(e.data.paidOn);
                                            return `${String(d.getDate()).padStart(2, "0")}-${String(
                                                d.getMonth() + 1
                                            ).padStart(2, "0")}-${d.getFullYear()}`;
                                        })()}
                                    </div>
                                </div>
                            ) : (
                                <Icon
                                    icon="mdi:clock-outline"
                                    title="Pending Payment"
                                    style={{ color: "gray", fontSize: "20px", opacity: 0.5 }}
                                />
                            )}
                        </div>
                    )}
                />
            </DataGrid>
        );
    };
    const renderDetail = (detailData) => {
        return <DetailContent detailData={detailData} />
    };

    useLayoutEffect(() => {
        const title = pendingIOMCount > 0 ? `My Tasks (${pendingIOMCount})` : "My Tasks";
        document.querySelector("#pageTitle").innerHTML = title;
        getMyTaskList();
        getProjectDropdownData();
    }, [pendingIOMCount]);

    const calculateCellValue2 = (dateValue) => {
        if (!dateValue) return "";
        const d = new Date(dateValue);
        const day = String(d.getDate()).padStart(2, "0");
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const paymentoptionChangeHandler = (value) => {
        const opt = (value === paymentOptionList[0]) ? true : false;
        setPaymentOption(opt);
        if (value === paymentOptionList[0]) {
            setErrors((pre) => ({ ...pre, paymentOption: "" }))
            setSelectedMsmeId(null)
        }
        if (value === paymentOptionList[1]) {
            setSelectedCompanyBankId(null)
            setErrors((pre) => ({ ...pre, paymentOption: "" }))
        }

        setPayment((pre) => ({
            ...pre,
            narration: "",
            transcationNumber: "",
            paymentModeId: "",
            paidDate: "",
            msmeId: ""
        }))


    }



    return (<>
        <div className="content">
            {/* Filters */}
            <div className="card filter">
                <div className="card-body">
                    <div className="row">
                        <div className='col-lg-3 col-md-3 col-sm-12'>
                            <label>
                                From <span className="text-danger">*</span>
                            </label>
                            <DateBox
                                placeholder="Select date"
                                value={filters?.fromDate}
                                onValueChanged={(e) => {
                                    e?.value && handleFilterChange("fromDate", e?.value)
                                }
                                }
                                displayFormat="dd/MM/yyyy"
                            />
                            {filterErrors?.fromDate && <span className="error invalid-feedback">{filterErrors?.fromDate}</span>}
                        </div>
                        <div className='col-lg-3 col-md-3 col-sm-12'>
                            <label>
                                To <span className="text-danger">*</span>
                            </label>
                            <DateBox
                                placeholder="Select date"
                                value={filters?.toDate}
                                onValueChanged={(e) => {
                                    e?.value && handleFilterChange("toDate", e?.value)
                                }}
                                displayFormat="dd/MM/yyyy"
                            />
                            {filterErrors?.toDate && <span className="error invalid-feedback">{filterErrors?.toDate}</span>}
                        </div>
                        <div className='col-lg-3 col-md-3 col-sm-12'>
                            <label>
                                Project <span className="text-danger"></span>
                            </label>
                            <SelectBox
                                //dataSource={[{ id: 1, name: 'New Infrastructure Project' }]}
                                dataSource={projectDropdownData}
                                valueExpr="id"
                                displayExpr="name"
                                className="form-control"
                                placeholder="Select"
                                searchEnabled
                                showClearButton={false}
                                value={filters?.projectId}
                                onValueChanged={(e) => {
                                    e?.value && handleFilterChange("projectId", e?.value)
                                }}
                            />
                            {/* {filterErrors?.toDate && <span className="error invalid-feedback">{filterErrors?.toDate}</span>} */}
                        </div>

                        <div className='col-lg-3 col-md-3 col-sm-12'>
                            <label style={{ display: "block" }}>&nbsp;</label>
                            <button
                                className="btn btn-primary btn-sm mt-2 mr-2"
                                title='Filter'
                                tooltip='Filter'
                                onClick={getMyTaskList}
                            >
                                <Icon className='iconify-size mr-1' icon="hugeicons:filter" />
                                Filter
                            </button>
                            <button
                                className="btn btn-outline-primary btn-sm mt-2"
                                title='Clear'
                                tooltip='Clear'
                                onClick={() => {
                                    setFilters(prevState => {
                                        return {
                                            ...prevState,
                                            fromDate: "",
                                            toDate: "",
                                            projectId: "",
                                        }
                                    })
                                    getMyTaskList(true);
                                }}
                            >
                                <Icon className='iconify-size mr-1' icon="hugeicons:eraser" />
                                Clear
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='card'>
                <div class="card-body">
                    <div class="tab-content" id="custom-tabs-tabContent">
                        <DataGrid
                            dataSource={iomList}
                            className='iom-grid'
                            // keyExpr="requestId"
                            columnAutoWidth
                            showBorders
                            showColumnLines={false}
                            showRowLines={true}
                            allowFiltering
                            columnHidingEnabled
                            onToolbarPreparing={(e) => {
                                e.toolbarOptions.items.unshift({
                                    location: 'before',
                                    widget: 'dxButton',
                                    options: {
                                        icon: 'refresh',
                                        text: 'Refresh',
                                        type: 'default',
                                        stylingMode: 'outlined',
                                        onClick: () => getMyTaskList()
                                    }
                                });
                            }}

                            // hide MasterDetail arrow in first column if isPaymentUpdatable is false
                            onRowPrepared={(e) => {
                                if (e?.rowType === "data" && !e?.data?.isPaymentUpdatable) {
                                    const expandCell = e?.rowElement.querySelector(".dx-command-expand");
                                    if (expandCell) {
                                        expandCell.innerHTML = "";
                                        expandCell.style.cursor = "default";
                                        expandCell.style.pointerEvents = "none"; // disable click
                                        expandCell.style.opacity = "0.6"; // optional: fade effect to indicate disabled
                                    }
                                }
                            }}
                        >
                            <MasterDetail enabled={true} render={renderDetail} />

                            <Column
                                width="80px"
                                cellRender={(cellData) => {
                                    const rowData = cellData?.data;
                                    return (
                                        <>
                                            {/* View */}
                                            <span title='View'>
                                                <Icon
                                                    title="View"
                                                    className='iconify-size'
                                                    icon="solar:document-text-outline"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() =>
                                                    (rowData?.requestTypeId === 2 ?
                                                        navigate("/iom-preview", { state: { iomId: rowData?.requestId, isPreviewOnly: true, fromPendingPage: true } })
                                                        :
                                                        rowData?.requestTypeId === 1 ? navigate("/view-fund-request", { state: { fundRequestId: rowData?.requestId, IsShowButtons: true, isEditAmt: true, isShowLedgerBalance: true } })
                                                            :
                                                            rowData?.requestTypeId === 3 ? navigate("/view-payment-request", { state: { paymentRequestId: rowData?.requestId, IsShowButtons: true, isEditAmt: true } })
                                                                : 0
                                                    )
                                                    }
                                                />
                                            </span>
                                            {/* Edit */}
                                            {([1, 2, 3].includes(rowData?.requestTypeId) && rowData?.toUserId !== user?.userId && !rowData?.isPaymentUpdatable
                                                ? (
                                                    <span title="Edit">
                                                        <Icon
                                                            title="Edit"
                                                            className='iconify-size mr-1'
                                                            icon="solar:pen-line-duotone"
                                                            style={{ cursor: 'pointer' }}
                                                            onClick={() => {
                                                                if (rowData?.requestTypeId === 2) {
                                                                    if (rowData?.isManual) {
                                                                        navigate("/new-inter-office-memo-old", { state: { iomId: rowData?.requestId } });
                                                                    } else {
                                                                        navigate("/new-inter-office-memo", { state: { iomId: rowData?.requestId } });
                                                                    }
                                                                } else if (rowData?.requestTypeId === 1) {
                                                                    navigate("/new-fund-request", { state: { fundRequestId: rowData?.requestId, isMytask: true } });
                                                                } else if (rowData?.requestTypeId === 3) {
                                                                    navigate("/add-edit-payment-request", { state: { paymentRequestId: rowData?.requestId, isMytask: true, IsShowButtons: true } });
                                                                }
                                                            }}

                                                        />
                                                    </span>
                                                ) : (
                                                    <span>
                                                        <Icon
                                                            title="Edit"
                                                            className='iconify-size'
                                                            icon="solar:pen-line-duotone"
                                                            style={{ cursor: 'pointer', pointerEvents: 'none', opacity: '0.3' }}
                                                        />
                                                    </span>
                                                ))}
                                        </>
                                    );
                                }}
                            />
                            <Column dataField="serialNo" caption="Request No." allowSearch={true} width='230px' allowFiltering={false}
                                cellRender={(e) => (
                                    <div style={{ 
                                        whiteSpace: 'normal', 
                                        wordBreak: 'break-all', 
                                        wordWrap: 'break-word' 
                                    }}>
                                        <div>{e.data?.serialNo}</div>
                                        <div style={{ lineHeight: '0.8rem' }}>
                                            <span style={{ fontSize: '11px', color: '#b1b1b1' }}>{e.data?.requestType}</span>

                                            <span
                                                style={{ display: (e?.data?.requestTypeId === 3 && e?.data?.isPaymentUpdatable) ? "" : "none" }}
                                                title="Payment Confirmation Pending"
                                            > <Icon
                                                    title="Payment Confirmation Pending"
                                                    className='iconify-size'
                                                    style={{ color: '#e10202', pointerEvents: 'none', cursor: 'pointer', padding: '0px', width: '15px', height: '15px' }}
                                                    icon="cuida:alert-outline"
                                                /></span><br></br>
                                            {e.data.requestStatusId === 15 ? <span style={{ fontSize: '11px', color: '#b1b1b1' }}> New</span> : null}
                                        </div>
                                    </div>
                                )}
                            />
                            <Column
                                caption="From"
                                cellRender={(e) => (
                                    <div>
                                        <div>{e.data.fromUser}</div>
                                        <div style={{ fontSize: '11px', color: '#b1b1b1' }}>{e.data.fromUserDepartment}</div>
                                    </div>
                                )}
                            />
                            <Column
                                caption="To"
                                dataField="toUser"
                                allowFiltering={false}
                                cellRender={(e) => (
                                    <div>
                                        <div>{e.data.toUser}</div>
                                        <div style={{ fontSize: '11px', color: '#b1b1b1' }}>{e.data.toUserDepartment}</div>
                                    </div>
                                )}
                            />
                            <Column
                                dataField="subject"
                                caption="Subject"
                                allowFiltering={false}
                                cellRender={(cellData) => (
                                    <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                                        {cellData.value}
                                    </div>
                                )}
                            />
                            <Column dataField="projectName" allowSearch={true} caption="Project" allowFiltering={false} />
                            <Column
                                dataField="createdDate"
                                allowFiltering={false}
                                caption="Created On"
                                width="120px"
                                cellRender={(e) => {
                                    const date = new Date(e.data?.createdDate);
                                    return (
                                        <>
                                            {date.toLocaleDateString('en-GB')}
                                            <div style={{ fontSize: '11px', color: '#b1b1b1' }}>
                                                {date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                            </div>
                                        </>
                                    );
                                }}
                            />
                            <Column
                                dataField="lastUpdatedOn"
                                caption="Last Updated"
                                allowFiltering={false}
                                width="150px"
                                cellRender={(e) => {
                                    if (!e.data.lastUpdatedOn) return null;
                                    const date = new Date(e.data.lastUpdatedOn);
                                    return (
                                        <div>
                                            {date.toLocaleDateString('en-GB')}&nbsp;
                                            {date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true })}
                                            <div style={{ color: '#b1b1b1', fontSize: '11px' }}>{e.data.lastUpdatedByUser}</div>
                                        </div>
                                    );
                                }}
                            />



                            <HeaderFilter visible={true} />
                            <SearchPanel visible={true} highlightCaseSensitive width={240} placeholder="Search..." />
                            <Paging defaultPageSize={15} />
                            <Pager
                                visible={true}
                                allowedPageSizes={[10, 15, 20, 50, 100]}
                                showPageSizeSelector={true}
                                showInfo={true}
                                showNavigationButtons={true}
                            />
                            <Export enabled={false} fileName="IOM" />
                        </DataGrid>
                    </div>
                </div>
                {/* </div> */}
            </div>
        </div>
        <Popup
            visible={isDeleteModalVisible}
            onHiding={() => setIsDeleteModalVisible(false)}
            dragEnabled={false}
            showTitle={true}
            title="Delete"
            height="auto"
            weight="auto"
            className='custom-modal-popup'
        >
            <div className='popup-body'>
                <label>Remark <span className="text-danger">*</span></label>
                <div className='form-group'>
                    <TextArea
                        value={remarks}
                        onValueChanged={handleRemarksChange}
                        height={90}
                        placeholder="Type your remarks..."
                    />
                    {error && (
                        <div style={{ color: "red", marginTop: 5 }}>{error}</div>
                    )}
                </div>
                <div className='text-right'>
                    <Button icon='close'
                        text="Cancel"
                        onClick={() => {
                            setIsDeleteModalVisible(false);
                            setRemarks("");
                            setError("");
                        }}
                        stylingMode="outlined"
                        className="btn btn-outline-primary btn-sm mr-2" />
                    <Button
                        icon='check'
                        text="Submit"
                        type="success"
                        onClick={handleSubmit}
                        className="btn btn-primary btn-sm"
                    />

                </div>
            </div>
        </Popup>

        {/* Payment Modal */}
        <Modal
            ariaHideApp={false}
            isOpen={isPaymentModalOpen}
            className="react-modal custom-modal-xlarge"
            onRequestClose={closeModal}
            shouldCloseOnOverlayClick={false}
            contentLabel="Payment Modal"
        >
            <form
                // onSubmit={}
                style={isSubmitted ? { pointerEvents: "none", opacity: 0.4 } : {}}
            >
                <div className="modal-header">
                    <h6 className="modal-title">
                        {"Payment Request "}
                    </h6>
                </div>
                <div className="modal-body">
                    <div className='row'>
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <table className='request-details'>
                                <tr>
                                    <td><Icon icon="hugeicons:file-02" className='iconify-style' /></td>
                                    <td>
                                        <div className='fieldlable'>Vendor</div>
                                        <div className='fieldvalue'>{payment?.vendorName}</div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div className='col-lg-3 col-md-3 col-sm-12'>
                            <table className='request-details'>
                                <tr>
                                    <td><Icon icon="si:rupee-fill" className='iconify-style' /></td>
                                    <td>
                                        <div className='fieldlable'>Ledger Balance</div>
                                        <div className='fieldvalue'>{payment?.balanceAmt}</div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div className='col-lg-3 col-md-3 col-sm-12'>
                            <table className='request-details'>
                                <tr>
                                    <td><Icon icon="si:rupee-fill" className='iconify-style' /></td>
                                    <td>
                                        <div className='fieldlable'>Recommended Amt.</div>
                                        <div className='fieldvalue'>{payment?.recommendedAmt}</div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div className='col-lg-3 col-md-3 col-sm-12'>
                            <table className='request-details'>
                                <tr>
                                    <td><Icon icon="si:rupee-fill" className='iconify-style' /></td>
                                    <td>
                                        <div className='fieldlable'>Amount to be Paid</div>
                                        <div className='fieldvalue'>{payment?.paidAmt}</div>
                                    </td>
                                </tr>
                            </table>
                        </div>

                    </div>


                    {/* payment option */}



                    <div className='row mt-2 mb-2'>

                        <div className='col-lg-9 col-md-8 col-sm-12'>
                            <div class="sub-title-color mb-0" style={{ fontSize: '0.9rem' }}>Select Payment Via</div>
                            <div>
                                <RadioGroup
                                    layout="horizontal"
                                    items={paymentOptionList}
                                    defaultValue={paymentOption}
                                    //onValueChanged={(e) => setPaymentOption(e.value)} 
                                    onValueChanged={(e) => paymentoptionChangeHandler(e.value)}
                                />
                            </div>
                        </div>

                    </div>
                    {errors?.paymentOption && <div className="text-danger error invalid-feedback">{errors.paymentOption}</div>}



                    {/* payment option */}

                    {(paymentOption === true) && (

                        <div className='mb-2'>
                            <label className='mb-1'>Select bank for payment to be done</label>
                            {/* DataGrid */}
                            {/* {branches.length > 0 && payment?.isAddBranch && ( */}
                            <DataGrid
                                dataSource={companyBankData}
                                keyExpr="companyBankId"
                                columnAutoWidth={true}
                                showColumnLines={false}
                                showRowLines={true}
                                showBorders={true}
                                allowColumnResizing={false}
                                height={185}
                            >
                                {/* Radio button column */}
                                <Column
                                    width={40}
                                    alignment='center'
                                    caption=""
                                    cellRender={({ data }) => (
                                        <input
                                            type="radio"
                                            name="companyBankSelect"
                                            checked={selectedCompanyBankId === data.companyBankId}
                                            onChange={() => handleValueChange("companyBankId", data.companyBankId)}
                                            style={{ cursor: "pointer" }}
                                        />
                                    )}
                                />

                                <Column dataField="bankName" caption="From Bank" />
                                <Column dataField="branchName" caption="Branch" />
                                <Column dataField="accountHolderName" caption="Account Holder Name" />
                                <Column dataField="accountNo" caption="Account Number" />
                                <Column dataField="accountType" caption="Account Type" />
                                <Column dataField="ifscCode" caption="IFSC Code" />
                                <Paging defaultPageSize={3} />
                            </DataGrid>

                            {errors?.companyBankId && <div className="text-danger error invalid-feedback">{errors.companyBankId}</div>}
                            {/* )} */}
                        </div>
                    )}

                    {(paymentOption === false) && (
                        <div className='mb-2'>
                            <label>MSME<span className="text-danger"></span></label>
                            <SelectBox
                                width={252}
                                dataSource={msme}
                                valueExpr="id"
                                displayExpr="name"
                                className="form-control"
                                placeholder="Select MSME"
                                searchEnabled
                                showClearButton={false}
                                value={payment?.msmeId}
                                onValueChanged={(e) => {
                                    e?.value && handleValueChange("msmeId", e?.value)
                                }}
                            />
                            {errors?.msmeId && <div className="text-danger error invalid-feedback" >{errors.msmeId}</div>}
                        </div>
                    )}




                    <div className='row'>
                        <div className='col-lg-3 col-md-3 col-sm-12'>
                            <label>Paid On<span className="text-danger"> *</span></label>
                            <DateBox
                                placeholder="Select date"
                                value={payment?.paidDate}
                                onValueChanged={(e) => {
                                    e?.value && handleValueChange("paidDate", e?.value)
                                }}
                                displayFormat="dd/MM/yyyy"
                            />
                            {errors?.paidDate && <div className="text-danger error invalid-feedback">{errors.paidDate}</div>}
                        </div>
                        <div className='col-lg-3 col-md-3 col-sm-12'>
                            <label>Payment Mode<span className="text-danger"> *</span></label>
                            <SelectBox
                                dataSource={paymentModeList}
                                valueExpr="id"
                                disabled={paymentOption === false ? true : false}
                                displayExpr="name"
                                className="form-control"
                                placeholder="Select payment mode"
                                searchEnabled
                                showClearButton={false}
                                value={paymentOption === false ? 1 : payment?.paymentModeId}
                                onValueChanged={(e) => {
                                    e?.value && handleValueChange("paymentModeId", e?.value)
                                }}
                            />
                            {errors?.paymentModeId && <div className="text-danger error invalid-feedback">{errors.paymentModeId}</div>}
                        </div>


                        {(paymentOption && (payment?.paymentModeId === 2 || payment?.paymentModeId === 3)) && (
                            <>
                                <div className='col-lg-3 col-md-3 col-sm-12'>
                                    <label>Cheque No.<span className="text-danger"> *</span></label>
                                    <TextBox
                                        placeholder='Enter Cheque number'
                                        value={payment?.chequeNo}
                                        onValueChanged={(e) => handleValueChange("chequeNo", e.value)}
                                    //height={70}
                                    />
                                    {errors?.chequeNo && <div className="text-danger error invalid-feedback">{errors.chequeNo}</div>}
                                </div>

                                <div className='col-lg-3 col-md-3 col-sm-12'>
                                    <label>Cheque Date<span className="text-danger"> *</span></label>
                                    <DateBox
                                        placeholder="Select date"
                                        value={payment?.chequeDate}
                                        onValueChanged={(e) => {
                                            e?.value && handleValueChange("chequeDate", e?.value)
                                        }}
                                        displayFormat="dd/MM/yyyy"
                                    />
                                    {errors?.chequeDate && <div className="text-danger error invalid-feedback">{errors.chequeDate}</div>}
                                </div>
                            </>

                        )}

                        <div className='col-lg-4 col-md-4 col-sm-12'>
                            <label>
                                Transaction Number <span className="text-danger">*</span>
                            </label>
                            <TextBox
                                placeholder='Enter transaction number'
                                value={payment?.transcationNumber}
                                onValueChanged={(e) => handleValueChange("transcationNumber", e.value)}
                            //height={70}
                            />
                            {errors?.transcationNumber && <div className="text-danger error invalid-feedback">{errors.transcationNumber}</div>}
                        </div>
                        <div className='col-lg-12 col-md-12 col-sm-12'>
                            <label>
                                Narration <span className="text-danger">*</span>
                            </label>
                            <TextArea
                                placeholder='Enter narration '
                                value={payment?.narration}
                                onValueChanged={(e) => handleValueChange("narration", e.value)}
                                height={70}
                            />
                            {errors?.narration && <div className="text-danger error invalid-feedback">{errors.narration}</div>}
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={closeModal}
                        title="Cancel"
                    >
                        <i className="fas fa-times"></i> Cancel
                    </button>

                    <button
                        //type="submit"
                        className="btn btn-primary btn-sm"
                        style={{ display: isSubmitted ? "none" : "" }}
                    >
                        {isSubmitted ? (
                            <span title="In process">
                                <i className="fas fa-spinner fa-spin"></i> In process
                            </span>
                        ) : (
                            <span title="Submit"
                                onClick={(e) => handlePaymentSubmit(e)}
                            >
                                <i className="fas fa-check"></i>{" "}
                                {payment?.id ? "Update" : "Submit"}
                            </span>
                        )}
                    </button>
                </div>
            </form>
        </Modal>

        {/* Payment deails Modal */}


        <PaymentDetailsModal paymentDeatilsByPrId={paymentDeatilsByPrId} paymentDeatilsSrno={paymentDeatilsSrno} closeModal={closeModal} isitemDetailsModalVisible={isitemDetailsModalVisible} isSubmitted={isSubmitted} />
    </>
    )
}





